import React from "react";
import type { UploadSectionProps } from "./types";
import { PUBLICATION_ACCEPT } from "./types";

export const ImageUploadSection: React.FC<UploadSectionProps> = ({ form, onFileChange, previewUrl, previewType }) => (
	<section className="flex flex-1 flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm min-h-[520px]">
		<div className="flex flex-1 flex-col gap-6 lg:flex-row">
			<div className="flex min-h-[360px] flex-col lg:w-[360px]">
				<header className="mb-4">
					<p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Step 2 · Upload image</p>
					<h2 className="mt-1 text-xl font-semibold text-slate-900">Pick the asset from your computer</h2>
					<p className="mt-2 text-sm text-slate-500">Choose the image to sync. The preview on the right updates instantly.</p>
				</header>
				<label className="text-xs font-semibold uppercase tracking-wide text-slate-500">File</label>
				<input
					type="file"
					className="mt-1 block w-full text-sm text-slate-600 file:mr-4 file:rounded-full file:border-0 file:bg-slate-900 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-white hover:file:bg-slate-800"
					accept="image/*"
					onChange={(event) => onFileChange(event.target.files ? event.target.files[0] : null)}
				/>
				{form.file && <p className="mt-1 text-xs text-slate-500">Selected: {form.file.name}</p>}
				<p className="mt-3 text-xs text-slate-400">Supported: PNG, JPG, GIF, WebP, SVG, BMP.</p>
			</div>
			<div className="flex h-full flex-1 min-h-[600px] items-center justify-center overflow-hidden rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-0">
							{previewUrl ? (
								previewType === "image" ? (
					<img src={previewUrl} alt="Selected preview" className="max-h-full max-w-full object-contain" />
					) : (
						<div className="flex h-full w-full flex-col items-center justify-center text-center text-sm text-slate-500">
							<p>Preview not available for this file type.</p>
							<p className="mt-1 text-xs text-slate-500">File name: {form.file?.name}</p>
						</div>
					)
				) : (
								<div className="flex flex-1 min-h-[600px] w-full flex-col items-center justify-center text-center text-sm text-slate-500">
						<p className="text-base font-semibold text-slate-700">No file selected</p>
						<p className="mt-2 text-xs text-slate-500">Choose a file on the left to visualize it here.</p>
					</div>
				)}
			</div>
		</div>
	</section>
);

export const PublicationUploadSection: React.FC<UploadSectionProps> = ({ form, onFileChange, previewUrl, previewType }) => (
	<section className="flex flex-1 flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm min-h-[520px]">
		<div className="flex flex-1 flex-col gap-6 lg:flex-row">
			<div className="flex min-h-[360px] flex-col lg:w-[360px]">
				<header className="mb-4">
					<p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Step 2 · Upload publication</p>
					<h2 className="mt-1 text-xl font-semibold text-slate-900">Attach the document</h2>
					<p className="mt-2 text-sm text-slate-500">PDF previews render on the right. Other document formats are still accepted.</p>
				</header>
				<label className="text-xs font-semibold uppercase tracking-wide text-slate-500">File</label>
				<input
					type="file"
					className="mt-1 block w-full text-sm text-slate-600 file:mr-4 file:rounded-full file:border-0 file:bg-slate-900 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-white hover:file:bg-slate-800"
					accept={PUBLICATION_ACCEPT}
					onChange={(event) => onFileChange(event.target.files ? event.target.files[0] : null)}
				/>
				{form.file && <p className="mt-1 text-xs text-slate-500">Selected: {form.file.name}</p>}
				<p className="mt-3 text-xs text-slate-400">Supported: PDF, DOC, DOCX, PPT, PPTX, TXT, RTF (preview shown for PDF).</p>
			</div>
			<div className="flex h-full flex-1 min-h-[600px] items-center justify-center overflow-hidden rounded-2xl border border-dashed border-slate-300 bg-slate-50 p-0">
				{previewUrl ? (
					previewType === "pdf" ? (
						<iframe
							src={`${previewUrl}#zoom=80`}
							title="PDF preview"
							className="h-full w-full bg-white"
							style={{ minHeight: "70vh" }}
						/>
					) : (
						<div className="flex h-full w-full flex-col items-center justify-center text-center text-sm text-slate-500">
							<p>Preview not available for this file type.</p>
							<p className="mt-1 text-xs text-slate-500">File name: {form.file?.name}</p>
						</div>
					)
				) : (
					<div className="flex flex-1 min-h-[600px] w-full flex-col items-center justify-center text-center text-sm text-slate-500">
						<p className="text-base font-semibold text-slate-700">No file selected</p>
						<p className="mt-2 text-xs text-slate-500">Choose a file on the left to visualize it here.</p>
					</div>
				)}
			</div>
		</div>
	</section>
);
